export default "__VITE_ASSET__DU281NeY__"